<template>
    <div :class="{ 'modal--full': fullScreen }" @click.stop class="modal" v-show="visible">
        <div :style="`max-width: ${width}px`" class="modal__contain">
            <div class="modal__header">
                <span>{{ title }}</span>
                <v-icon @click.native="$emit('close')" name="close" />
            </div>
            <div class="modal__body">
                <slot />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        width: {
            type: String,
            required: true
        },
        fullScreen: {
            type: Boolean,
            required: false,
            default: false
        },
        title: {
            type: String,
            required: true
        }
    }
}
</script>

<style lang="scss">
.modal {
    position: fixed;
    z-index: 2000;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100%;
    background-color: rgba(#000000, 0.8);
    &__contain {
        width: calc(100% - 2rem);
        position: absolute;
        top: 2rem;
        left: 50%;
        transform: translateX(-50%);
    }
    &__header {
        height: 41px;
        width: 100%;
        padding-left: 1rem;
        padding-right: 1rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #b1b1b1;
        border-radius: 4px 4px 0 0;
        background-color: #b1b1b1;
        span {
        }
        svg {
            cursor: pointer;
            height: 20px;
            width: 20px;
            border-radius: 4px;
            transition: all 0.5s;
            &:hover {
                background-color: #b1b1b1;
            }
        }
    }
    &__body {
        max-height: calc((100vh - 4rem) - 41px);
        overflow: hidden auto;
        padding: 1rem;
        border-radius: 0 0 4px 4px;
        background-color: #ffffff;
    }

    @media (max-width: 576px) {
        &__body {
            max-height: 100%;
        }
        &--full {
            .modal {
                &__contain {
                    height: 100%;
                    width: 100%;
                    max-width: 100% !important;
                    top: 0;
                    display: flex;
                    flex-direction: column;
                }
                &__header {
                    border-radius: 0;
                }
                &__body {
                    flex-grow: 1;
                    border-radius: 0;
                }
            }
        }
    }
}
</style>
